<template>
  <div>
    <div style="background: #fff" class="todaySelected-top1">
      <div>
        <div>
          <div v-for="(item, index) in list" :key="index">
            <div class="yanbao_time" v-if="item.show == 1">
              {{ item.orderDate.slice(0, 4) }}-{{
                item.orderDate.slice(4, 6)
              }}-{{ item.orderDate.slice(6 - 8) }}
            </div>
            <div
              class="stock_mybody"
              :class="item.dealType == '1' ? 'red' : 'blue'"
            >
              <div style="width: 2.08rem">
                <div class="top" style="font-size: 0.32rem; font-weight: 500">
                  {{ item.stockName }}
                </div>
                <div class="bottom">
                  <div class="buy_sell">
                    <span :class="item.dealType == 1 ? 'buy' : 'sell'">{{
                      item.dealType == 1 ? "买" : "卖"
                    }}</span>
                    <span style="padding-top: 0.04rem">{{
                      item.orderTime
                    }}</span>
                  </div>
                </div>
              </div>
              <div style="width: 1.8rem; font-weight: 500">
                <div class="top">{{ item.dealPrice }}</div>
              </div>
              <div style="width: 1.3rem; font-weight: 500">
                <div class="top">{{ item.dealNum }}</div>
              </div>

              <div
                style="
                  width: 1.65rem;
                  text-align: right;
                  font-size: 0.34rem;
                  font-weight: 500;
                "
              >
                <div class="top">
                  <!-- {{ item.stockName }} -->
                  {{ item.dealValue.toFixed(2) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
import { Tab, Tabs } from "vant";
export default {
  components: { [Tab.name]: Tab, [Tabs.name]: Tabs },
  props: {
    list: Array,
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  height: 100vh;
  // overflow: hidden;
  background: #f5f5f5;
  padding-top: 0.87rem;
}
.main-centent {
  padding: 0 0 0 0.32rem;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.stock_mybody {
  height: 1.2rem;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 0.32rem;
  font-size: 0.3rem;
  border-bottom: 0.01rem solid #e8e8e8;
}
.stock_mybody .van-collapse-item {
  padding: 0 0 0 0 !important;
}
.bottom {
  font-size: 0.28rem;
  // color: #999999;
}
.top {
  // color: #333333;
  font-size: 0.36rem;
  line-height: 0.5rem;
}
.buy_sell {
  display: flex;
  align-items: center;
}
.buy {
  font-size: 0.2rem;
  width: 0.28rem;
  height: 0.28rem;
  background: #e5464d;
  margin-right: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sell {
  font-size: 0.2rem;
  width: 0.28rem;
  height: 0.28rem;
  background: #5187d4;
  margin-right: 0.04rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.red {
  color: #ec333b;
}
.blue {
  color: #5187d4;
}
.yanbao_time {
  // width: 100%;
  height: 0.45rem;
  background: #f5f5f5;
  padding-left: 0.32rem;
  display: flex;
  align-items: center;
  // border-top: 0.02rem solid #fff;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.7rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}
</style>